export default "__VITE_ASSET__DWNFB8ja__"